<pgh-modal-window>
  <div modal-close style="margin-bottom: 10px">
    <button
      mat-icon-button
      class="close-button mat-icon-button"
      (click)="onCancelClicked()"
      sf-aria-label="Global_Close_Window"
      matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div modal-title>
    <h4>
      <adp-label labelKey="Account_Manage_Members_EditMember_Title"></adp-label>
    </h4>
  </div>
  <div modal-body class="mt-30 mb-30">
    <form [formGroup]="memberDetailsForm" name="PaymentFormGroup">
      <div class="row">
        <div class="col-md-12 mb-3 full-width">
          <adp-input [resourceData]="getResource('FirstName')" formControlName="firstName" (keypress)="isLetters($event)"></adp-input>
        </div>
        <div class="col-md-12 mb-3 full-width">
          <adp-input [resourceData]="getResource('LastName')" formControlName="lastName" (keypress)="isLetters($event)"></adp-input>
        </div>
        <div class="full-width phone-number-field">
          <adp-input
            pgh-autofocus
            [resourceData]="getResource('PhoneNumber', 'Account_Manage_Members_EditMember')"
            formControlName="phoneNumber"
            class="w-100"
            (blur)="validatePhoneNumber()"
            [hideValidationMessage]="false">
          </adp-input>
          <mat-error *ngIf="validationError" class="text-danger">{{ validationError }}</mat-error>
        </div>
      </div>
    </form>
  </div>
  <div modal-footer>
    <div class="row reverse-wrap">
      <div class="col-md-6">
        <button
          mat-stroked-button
          color="primary"
          class="border-0"
          (click)="onCancelClicked()"
          [gtmClick]="getViewLabel('Global_Button_Cancel')">
          <adp-label labelKey="Global_Button_Cancel"></adp-label>
        </button>
      </div>
      <div class="col-md-6">
        <button
          mat-flat-button
          color="accent"
          (click)="onSaveClicked()"
          [disabled]="memberDetailsForm.invalid || isSaving || validationError"
          [gtmClick]="getViewLabel('Global_Button_Save')">
          <adp-label labelKey="Global_Button_Save"></adp-label>
        </button>
      </div>
    </div>
  </div>
</pgh-modal-window>
